"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var badge_1 = require("./badge");
Object.defineProperty(exports, "Badge", { enumerable: true, get: function () { return badge_1.Badge; } });
//# sourceMappingURL=index.js.map